import { render, staticRenderFns } from "./ActionsDropdown.vue?vue&type=template&id=504a3527"
import script from "./ActionsDropdown.vue?vue&type=script&lang=js"
export * from "./ActionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ActionsDropdown.vue?vue&type=style&index=0&id=504a3527&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports